import { useServiceWorkerUpdate } from "@khazzin/ui/patterns/serviceWorker";
import { Button } from "@khazzin/ui/primitives/Button";
import { useI18n } from "../i18n";
import { SyncCard } from "./shell/Profile";

/**
 * The forced upgrade (EP10-S23, DA-10-23, `10/03` §9): the server refused this
 * build, so no outcome can be started. The Sync card stays, because what the
 * driver already captured still goes up — `/sync/push` is never refused — and
 * Update now moves onto the new build.
 */
export function UpgradeGate() {
	const { t } = useI18n();
	const { apply } = useServiceWorkerUpdate();

	return (
		<main className="flex min-h-screen flex-col items-center gap-6 bg-bg-canvas px-5 py-10">
			<div className="flex w-full max-w-[400px] flex-col gap-4 card p-8 text-center">
				<img src="/icon.svg" alt="" width={64} height={64} className="mx-auto" />
				<div className="flex flex-col gap-1">
					<h1 className="text-[15px] font-bold tracking-tight text-fg">
						{t("common.upgrade.title")}
					</h1>
					<p className="text-[13px] leading-relaxed text-fg-muted">{t("common.upgrade.body")}</p>
				</div>
				<Button variant="primary" size="lg" onClick={apply}>
					{t("common.upgrade.updateNow")}
				</Button>
			</div>
			<div className="w-full max-w-[400px]">
				<SyncCard />
			</div>
		</main>
	);
}
